export default __webpack_public_path__ + "static/The Home_Image 5_carousel 2@2x-da9a8b48f8e77a2282ace01a08b0b25c.jpg";